<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0 back-image-doc">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class>
            <div class>
              <!--div class="pt-4 pb-2 border-bottom text-center">
                <h3>
                  Reseliance Calculation
                  <span class="font-weight-light"></span>
                </h3>
                <div class="h6 font-weight-300">
                  <i class="ni location_pin mr-2"></i>
                  This is the documentation of Job Navigater
                </div>
              </div-->
              <div class="text-center mt-4">
                <img
                  src="img/theme/contribute.png"
                  style="height:100%; max-height:200px; margin-top:0px; margin-right:20px; margin-left:20px"
                />
                <h1>Contribute</h1>
              </div>
              <div class="px-5 mt-5 mb-5">
                <p>
                  In this page you can find the list of the robotic
                  abilities, grouped by families, along with their
                  <a
                    href="https://www.eu-robotics.net/cms/upload/topic_groups/H2020_Robotics_Multi-Annual_Roadmap_ICT-2017B.pdf"
                  >MAR</a> definition, which have been considered in our analysis.
                </p>

                <p>
                  By clicking on the button below, you will be directed to
                  a simple survey to express your opinion on the TRL evaluation of one of these abilities.
                  Choose the ability that you are expert in and contribute!
                </p>

                <p>
                  <center>
                    <base-button
                      tag="a"
                      href="#"
                      class="mb-3 mb-sm-0"
                      @click="()=>{survey.show = true; survey.activeQuestion=0 }"
                    >Contribute</base-button>
                  </center>
                </p>

                <h5>Adaptability abilities</h5>

                <p>
                  <b>Recognition of the need for parameter adaptation</b>, i.e.,
                  the system recognizes the need for parameter adaptation.
                </p>

                <p>
                  <b>Individual parameter adaptation</b>, i.e., the system
                  alters individual parameters in any part of the system based
                  on assessments of performance local to the module on which the
                  parameter operates.
                </p>

                <p>
                  <b>Multiple parameter adaptation</b>, i.e., the system alters
                  several parameters based on the aggregate performance of a set
                  of interconnected or closely coupled modules.
                </p>

                <p>
                  <b>Adaptation of individual components</b>, i.e., the system
                  selects one of several processing components based on online
                  feedback during operation.
                </p>

                <p>
                  <b>Recognition of the need for task adaptation</b>, i.e., the
                  system recognises that the performance of a particular task
                  could be optimised according to some metric, but no adaptation
                  is performed.
                </p>

                <p>
                  <b>Multiple task adaptation</b>, i.e., a set of tasks
                  performed during the process cycle is adapted over time to
                  optimise a particular metric; adaptation is the result of
                  accumulated experience.
                </p>

                <h5>Interaction ability</h5>

                <p>
                  <b>Direct physical human-robot interaction</b>, i.e., the user
                  controls the robot by physically interacting with it. The
                  robot reacts to the user interaction by feeding back physical
                  information to the user via the contact point.
                </p>

                <h5>Motion abilities</h5>

                <p>
                  <b>Pre-defined closed-loop motion</b>, i.e., the robot carries
                  out pre-defined moves in sequence where each motion is
                  controlled to ensure position and/or speed goals are satisfied
                  within some error bound.
                </p>

                <p>
                  <b>Parameterised motion</b>, i.e., the robot can execute a
                  path move that optimises for a parameter.
                </p>

                <p>
                  <b>Position constrained parameterised motion</b>, i.e., the
                  robot can operate through a physically constrained region
                  while at the same time optimising a parameter or set of
                  parameters that constrain the motions of the robot.
                </p>

                <h5>Manipulation abilities</h5>

                <p>
                  <b>Complex object grasping</b>, i.e., the robot is able to
                  pick up an object belonging to a certain parameterised type
                  where the object can be articulated, or consists of multiple
                  separate parts.
                </p>

                <p>
                  <b>Unknown object handling</b>, i.e., the robot is able to
                  determine the generic grasping properties of an unknown
                  object. It is able to use those properties to determine how to
                  handle and place the object.
                </p>

                <h5>Decisional autonomy ability</h5>

                <p>
                  <b>Dynamic autonomy</b>, i.e., the system is able to alter its
                  decisions about actions (sub-tasks) within the time frame of
                  dynamic events that occur in the environment so that the
                  execution of the task remains optimal to some degree.
                </p>

                <h5>Perception abilities</h5>

                <p>
                  <b>Direct single and multi-parameter sensing</b>, i.e., a
                  robot uses sensors that provide a single, or multiple
                  parameter output directly, for example a distance sensor, or a
                  contact sensor. The robot utilizes these outputs to directly
                  alter behavior within an operating cycle.
                </p>

                <p>
                  <b>Object detection</b>, i.e., multiple persistent features
                  can be grouped to build models of distinct objects allowing
                  objects to be differentiated from each other and from the
                  environment.
                </p>

                <p>
                  <b>Context-based recognition</b>, i.e., the system is able to
                  use its knowledge of context or location to improve its
                  ability to recognise objects by reducing ambiguities through
                  expectations based on location or context.
                </p>

                <p>
                  <b>Multiple object detection</b>, i.e., the system is able to
                  delineate multiple objects from the static environment where
                  there may be partially occluded with respect to the sense data
                  gathered.
                </p>

                <p>
                  <b>Feature-based location</b>, i.e., the system calculates its
                  position within an environment based on the motion of fixed
                  features in the environment.
                </p>

                <h5>Cognitive abilities</h5>

                <p>
                  <b>Flexible object interaction</b>, i.e., the system is able
                  to envision the effect its planned actions will have on
                  flexible objects that it has parameterised.
                </p>

                <p>
                  <b>Interaction acquisition</b>, i.e., the system is able to
                  acquire knowledge about its environment and objects within it
                  through planned interactions with the environment and objects.
                </p>

                <p>
                  <b>Observation learning</b>, i.e., the system is able to
                  acquire knowledge indirectly from observing other robots or
                  people carrying out tasks.
                </p>

                <p>
                  <b>Pre-defined reasoning</b>, i.e., the robot is able to use
                  basic pre-defined knowledge about structures and objects in the
                  environment to guide action and interaction.
                </p>

                <p>
                  <b>Task reasoning</b>, i.e., the system is able to reason
                  about the appropriate courses of action to achieve a task
                  where there are alternative actions that can be undertaken.
                  Typically the system will be able to identify the course of
                  action which matches the desired task parameters, typically
                  these involve time to completion, resource usage, or a desired
                  performance level.
                </p>

                <p>
                  <b>Social interaction</b>, i.e., the system is able to
                  maintain dialogues that cover more than one type of social
                  interaction, or domain task. The robot is able to manage the
                  interaction provided it remains within the defined context of
                  the task or mission.
                </p>

                <p>
                  <b>Intuitive interaction</b>, i.e., the robot is able to
                  intuit the needs of a user with or without explicit command or
                  dialogue. The user may communicate to the robot without
                  issuing explicit commands. The robot will intuit from the
                  current context and historical information the implied
                  command.
                </p>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>
    <!-- Survery model -->
    <modal :show.sync="survey.show">
      <div slot="header">
        <!--h2>Q{{survey.surveys[survey.activeQuestion].questionNumber}}</h2-->
        <b>{{survey.surveys[survey.activeQuestion].question}}</b>
      </div>

      <!-- <p>{{survey.surveys[survey.activeQuestion].question}}</p> -->
      <auto-complete
        v-if="survey.surveys[survey.activeQuestion].type=='search'"
        alternative
        :placeholder="survey.surveys[survey.activeQuestion].placeholder"
        addon-left-icon="ni ni-zoom-split-in"
        addon-right-icon="ni ni-bold-down"
        :options="survey.surveys[survey.activeQuestion].options"
        @select-item="selectExpertise"
      ></auto-complete>

      <div v-if="survey.surveys[survey.activeQuestion].type=='radio'">
        <div
          v-for="(option,index) in survey.surveys[survey.activeQuestion].options"
          v-bind:key="option"
        >
          <base-radio
            :name="index"
            class="mb-3"
            v-model="survey.surveys[survey.activeQuestion].answer"
          >{{option}}</base-radio>
        </div>
      </div>

      <div
        v-if="survey.surveys[survey.activeQuestion].type=='info'"
      >
      <p v-html="survey.surveys[survey.activeQuestion].text_info"></p>
      </div>

      <div
        v-if="survey.surveys[survey.activeQuestion].type=='success'"
      > 
      <p v-html="survey.emailText"></p>
      </div>

      <div v-if="survey.surveys[survey.activeQuestion].type=='text'">
        <base-input
          alternative
          placeholder="Answer"
          v-model="survey.surveys[survey.activeQuestion].answer"
        ></base-input>
      </div>

      <div v-if="survey.surveys[survey.activeQuestion].type=='final'">
        <base-alert v-if="survey.surveys[survey.activeQuestion].hasError == true" type="danger" icon="ni ni-support-16" dismissible>
                <span slot="text">Please enter all the fields and submit again!</span>
            </base-alert>
          
        <base-input
          alternative
          placeholder="Title"
          v-model="survey.surveys[survey.activeQuestion].title"
        ></base-input>
        <base-input
          alternative
          placeholder="Name and Family Name"
          v-model="survey.surveys[survey.activeQuestion].name"
        ></base-input>
        <base-input
          alternative
          placeholder="Company/University"
          v-model="survey.surveys[survey.activeQuestion].company"
        ></base-input>
        <base-input
          alternative
          placeholder="Email"
          v-model="survey.surveys[survey.activeQuestion].email"
        ></base-input>
      </div>

      <template slot="footer">
        
        <base-button
          v-if="survey.surveys[survey.activeQuestion].type!='final' && survey.surveys[survey.activeQuestion].type!='info'"
          :disabled="survey.surveys[survey.activeQuestion].answer==-1"
          type="primary"
          class="ml-auto"
          @click="surveyNext"
        >Next</base-button> 
        <div v-else style="    width: 100%;  display: inherit;">
          <base-checkbox v-model="survey.surveys.checked">I agree to terms and conditions</base-checkbox>
        <base-button type="primary" class="ml-auto" @click="surveyNext" :disabled="!survey.surveys.checked">Next</base-button>
        </div>
        <!-- <base-button type="link" class="ml-auto" @click="survey.show = false">Close</base-button> -->
      </template>
    </modal>
  </div>
</template>
<script>
import AutoComplete from "./../views/components/AutoComplete";
import Modal from "@/components/Modal.vue";

export default {
  components: {
    AutoComplete,
    Modal
  },
  data() {
    return {
      survey: {
        emailText: "",
        show: false,
        activeQuestion: 0,
        surveys: [
          {
            questionNumber: 100,
            type: "info",
            question:
              "Terms and conditions",
            answer: "",
            text_info:
              "<i>Thank you for your contribution!</i> <br> <br> We want to improve our Technology Readiness Level assessment of the robotic abilities, and we appreciate that you are willing to share your expertise with us and take this short survey.  In addition to your opinion, we will also collect some personal data such as your name, your email address and your professional affiliation, to be able to contact you later if needed. We securely store this data for one year. We respect your trust and privacy, and therefore  will never sell or share this data with third parties. By filling this form you agree to let us collect and use your data for the purpose of this research. <br> <br> If you have any question or you change your mind in the future, please send an email to TRLevaluation@epfl.ch."
          },
          {
            checked:false,
            questionNumber: 1,
            type: "search",
            question: "Choose the ability you are expert in.",
            placeholder: "Choose an ability",
            answer: -1,
            options: [
              { name: "Adaptation of individual components" },
              { name: "Basic environment envisioning" },
              { name: "Complex object grasping" },
              { name: "Context-based recognition" },
              { name: "Direct physical interaction" },
              { name: "Direct single and multi-parameter sensing " },
              { name: "Dynamic autonomy " },
              { name: "Feature-based location" },
              { name: "Flexible object interaction" },
              { name: "Individual Parameter adaptation " },
              { name: "Interaction acquisition " },
              { name: "Intuitive interaction " },
              { name: "Multiple object detection " },
              { name: "Multiple parameter adaptation " },
              { name: "Multiple task adaptation " },
              { name: "Object detection " },
              { name: "Observation learning " },
              { name: "Parameterised motion " },
              { name: "Position constrained parameterised motion " },
              { name: "Pre-defined closed-loop motion " },
              { name: "Pre-defined reasoning " },
              { name: "Recognition of the need for parameter adaptation " },
              { name: "Recognition of the need for task adaptation " },
              { name: "Social interaction " },
              { name: "Task reasoning " },
              { name: "Unknown object handling" }
            ]
          },
          {
            questionNumber: 2,
            type: "radio",
            question:
              "At which of the following levels would you assess the current technology behind the chosen ability?",
            answer: -1,
            options: [
              "Early stage: research started, theory not fully clear yet",
              "Development stage: technology is a solved problem from a theoretical point of view; prototype ready for technological assessment",
              "Maturity stage: technology assessed with final demonstrations and/or show-cases"
            ]
          },
          {
            questionNumber: 3,
            type: "radio",
            question:
              "Please select one among the following options to further describe the technological status behind the chosen ability.",
            answer: -1,
            options: [
              "Basic principles observed (TRL = 1)",
              "Technology concept formulated (TRL = 2)",
              "Experimental proof of concept (TRL = 3)"
            ]
          },
          {
            questionNumber: 3,
            type: "radio",
            question:
              "Please select one among the following options to further describe the technological status behind the chosen ability.",
            answer: -1,
            options: [
              "Technology validated in lab (TRL = 4)",
              "Technology validated in relevant environment (TRL = 5)",
              "Technology demonstrated in relevant environment (TRL = 6)"
            ]
          },
          {
            questionNumber: 3,
            type: "radio",
            question:
              "Please select one among the following options to further describe the technological status behind the chosen ability.",
            answer: -1,
            options: [
              "System prototype demonstration in operational environment (TRL = 7)",
              "System completed and qualified (TRL = 8)",
              "Actual system proven in operational environment (TRL = 9)"
            ]
          },
          {
            questionNumber: 4,
            type: "text",
            question:
              "At best of your knowledge, which commercial product (e.g., software library, hardware device, etc.) and/or scientific outcome (papers, patents, etc.) best proves the current technological status behind the given ability? Click 'Next' to skip it.",
            options: "",
            answer: ""
          },
          {
            questionNumber: 5,
            type: "radio",
            question:
              "How long do you expect it will take for the technology behind the chosen ability to reach the stage where the actual system is ready and working in operational environment?",
            answer: -1,
            options: [
              "It already exists",
              "Up to 5 years",
              "Up to 10 years",
              "20 years or more"
            ]
          },
          {
            questionNumber: 6,
            type: "final",
            question:
              "Please provide your contact information and authorize the information you are submitting",
            name: "",
            email: "",
            title: "",
            company: "",
            hasError: false
          },
          {
            questionNumber: 0,
            type: "success",
            question: "Thank you for your contribution! Please copy/paste this message and send it to TRLevaluation@epfl.ch."
          }
        ]
      }
    };
  },
  methods: {
    selectExpertise(expertise) {
      if (expertise == "") {
        console.log("No expertise Selected");
      } else {
        this.survey.surveys[this.survey.activeQuestion].answer = expertise;
        this.survey.emailText = "Dear Resilience to Robots team, <br><br> I would like to improve the TRL evaluation for the robotic ability "
        this.survey.emailText += " '" +expertise.name+ "'. Please find here the recap of my survey.";
        this.survey.activeQuestion++;
        // this.$router.push({ name: "profile", params: { occupation: option } });
      }
      console.log(expertise);
    },
    surveyNext() {
      if(this.survey.activeQuestion == 9){
        //THis is the last question
        const confirm = window.confirm("Did you send the email already?");
        if(confirm){
          window.location.reload(false); 
        }
      }
      if (this.survey.surveys[this.survey.activeQuestion].answer != -1) {
        //Navigation logic
        if (
          this.survey.activeQuestion == 2 &&
          this.survey.surveys[this.survey.activeQuestion].type == "radio"
        ) {
          this.survey.emailText += "<br> 1) Technology is at a: '" + this.survey.surveys[this.survey.activeQuestion].options[this.survey.surveys[this.survey.activeQuestion].answer] + "'.";
          // THis is deciding question and updte the next questions based on answer
          this.survey.activeQuestion +=
            this.survey.surveys[this.survey.activeQuestion].answer + 1;
            
        } else if (
          this.survey.activeQuestion == 3 ||
          this.survey.activeQuestion == 4 ||
          this.survey.activeQuestion == 5
        ) {

          this.survey.emailText += "<br> 2) TRL evaluation: '" + this.survey.surveys[this.survey.activeQuestion].options[this.survey.surveys[this.survey.activeQuestion].answer] + "'.";
          // all these should take to the next question which is in location 5
          this.survey.activeQuestion = 6;
        } else if (this.survey.activeQuestion == 6) {
            this.survey.emailText += "<br> 3) Best available product/research: '" + this.survey.surveys[this.survey.activeQuestion].answer + "'.";
            this.survey.activeQuestion++;
        } else if(this.survey.activeQuestion == 7){
          this.survey.emailText += "<br> 4) Expected period to see this ability operational: '" + this.survey.surveys[this.survey.activeQuestion].options[this.survey.surveys[this.survey.activeQuestion].answer] + "'.";
          this.survey.activeQuestion++;
        }  else if(this.survey.activeQuestion == 8){
          if(this.survey.surveys[8].email == "" || this.survey.surveys[8].title== "" || this.survey.surveys[8].name == "" || this.survey.surveys[8].company== ""){
            this.survey.surveys[8].hasError = true;
            return
          }else{
            this.survey.surveys[8].hasError = false
          }
          this.survey.emailText += "<br><br> I agree to the terms and conditions written below. <br>";
          this.survey.emailText += "<br> Best regards, <br>" ;
          this.survey.emailText += this.survey.surveys[this.survey.activeQuestion].title + " " + this.survey.surveys[this.survey.activeQuestion].name + ", ";
          this.survey.emailText += "<br> " + this.survey.surveys[this.survey.activeQuestion].company + ", ";
          this.survey.emailText += this.survey.surveys[this.survey.activeQuestion].email + ". ";
          this.survey.emailText += '<br> <br> <font size="2"> <i> TERMS and CONDITIONS: We want to improve our Technology Readiness Level assessment of the robotic abilities, and we appreciate that you are willing to share your expertise with us and take this short survey.  In addition to your opinion, we will also collect some personal data such as your name, your email address and your professional affiliation, to be able to contact you later if needed. We securely store this data for one year. We respect your trust and privacy, and therefore  will never sell or share this data with third parties. By filling this form you agree to let us collect and use your data for the purpose of this research. If you have any question or you change your mind in the future, please send an email to TRLevaluation@epfl.ch. </i></font>';

          this.survey.activeQuestion++;
        }else {
          this.survey.activeQuestion++;
        }
      } else {
        console.log("No answer - " + this.survey.activeQuestion);
      }
    },
    submitSurvey() {
      if (
        this.survey.surveys[this.survey.activeQuestion].name != "" &&
        this.survey.surveys[this.survey.activeQuestion].email != ""
      ) {
        this.survey.emailText += "<br>Thanks in advance. <br> Regards,<br>" +this.survey.surveys[this.survey.activeQuestion].title +". " +this.survey.surveys[this.survey.activeQuestion].name;
          this.survey.emailText += "<br> "+ this.survey.surveys[this.survey.activeQuestion].email;
          this.survey.emailText += "<br> "+ this.survey.surveys[this.survey.activeQuestion].company;
          console.log(this.survey.emailText)
          window.open('mailto:antonio.paolillo@epfl.ch;nicola.nosengo@epfl.ch?subject=Contribution&body='+encodeURIComponent(this.survey.emailText));
        this.survey.activeQuestion++;
      }
    }
  },
  computed:{
    test(){
      console.log(this.survey.emailText)
      return true;
    }
  }
};
</script>
<style></style>
